/* Sitewide section reveal-on-scroll — FAIL-OPEN, no wrapper.
   Animates CONTENT sections only (header/footer/announcement excluded) and
   only pre-hides those below the fold. Above-fold + excluded stay visible. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SKIP = /header|footer|announce|scroll-to-top|marquee|cart-drawer|cart-notification|human.?body|human_body|custom-bestsellers|main-collection-product-grid/i;
  function run() {
    var all = [].slice.call(document.querySelectorAll('.shopify-section'));
    var secs = all.filter(function (s) {
      if (SKIP.test(s.id || '')) return false;
      var pos = getComputedStyle(s).position;
      if (pos === 'fixed' || pos === 'sticky') return false;
      return true;
    });
    if (!secs.length || !('IntersectionObserver' in window)) return; // leave visible
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var pending = [];
    secs.forEach(function (s) {
      if (s.getBoundingClientRect().top >= vh * 0.85) { s.classList.add('flow-pending'); pending.push(s); }
    });
    if (!pending.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('flow-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    pending.forEach(function (s) { io.observe(s); });
    setTimeout(function () { pending.forEach(function (s) { s.classList.add('flow-in'); }); }, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
